export default {
    namespaced: true,

    state: {
        cities: [],
        post_codes: [],
    },

    getters: {
        getCities(state) {
            return state.cities;
        },

        getPostCodes(state) {
            return state.post_codes;
        },
    },

    mutations: {
        setCities(state, value) {
            state.cities = value;
        },

        setPostCodes(state, value) {
            state.post_codes = value;
        },
    },
};